import { useQuery } from '@apollo/client';
import * as React from 'react';
import { GET_EVENT_REGISTRATIONS } from '../graphql/queries';
import { isUserRegisteredForTicket } from '../components/ticketUtils';

export const useEventRegistrations = (eventId: string | undefined, user: any) => {
  const { data: registrationsData, loading: registrationsLoading } = useQuery(GET_EVENT_REGISTRATIONS, {
    variables: { eventId },
    skip: !eventId || !user,
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  const getIsUserRegisteredForTicket = React.useCallback(
    (ticketId: string) => isUserRegisteredForTicket(ticketId, user?._id, registrationsData),
    [user?._id, registrationsData]
  );

  return {
    registrationsData,
    registrationsLoading,
    getIsUserRegisteredForTicket,
  };
};
